import { IAllProps } from '@tinymce/tinymce-react';
import { useRef } from 'react';
import { toast } from 'react-toastify';
import RichTextEditor from '../../../component/richtext-editor';
import { CODE, RESPONSE_MESSAGE } from '../../../utils/Constant';
import { uploadRispacImage } from '../../services/PhanHeCDHAVaTDCNService';

type Props = IAllProps & {
	rispacOrder?: any;
	onUploadImageSuccess?: (fileUploaded: any) => void;
};

const NhapKetQuaCDHAEditor = ({ rispacOrder, onUploadImageSuccess, ...props }: Props) => {
	const editorRef = useRef<any>(null);

	const imageUploadHandler = (blobInfo: any, progress: any) =>
		new Promise(async (res, rej) => {
			try {
				const file = blobInfo.blob();
				const formData = new FormData();
				formData.append('files', file);

				const { code, data } = await uploadRispacImage(rispacOrder?.orderId, formData);
				if (CODE.SUCCESS === code) {
					const imageUploaded = data[0];
					onUploadImageSuccess?.(imageUploaded);
					res(imageUploaded.url);
					progress(100);
				}
			} catch (error: any) {
				console.error(error?.message);
				rej(error);
			}
		});

	return (
		<RichTextEditor
			ref={editorRef}
			initialOptions={{
				automatic_uploads: true,
				images_upload_handler: imageUploadHandler,
				notifications: false,
				images_reuse_filename: true,
				remove_script_host: false,
				convert_urls: false,
				file_picker_callback: (callback: any) => {
					const input = document.createElement('input');
					input.setAttribute('type', 'file');
					input.setAttribute('multiple', 'false');
					input.setAttribute('accept', 'audio/*, video/*, image/*');
					input.addEventListener('change', (e: Event) => {
						const target = e.target as HTMLInputElement;
						const files = target.files;
						const file = files?.[0];

						if (!file) return;

						const reader = new FileReader();
						reader.onload = async function () {
							try {
								const form = new FormData();
								form.append('files', file);

								const { code, data } = await uploadRispacImage(
									rispacOrder?.orderId,
									form
								);

								if (CODE.SUCCESS !== code) {
									toast.error(RESPONSE_MESSAGE.ERROR);
									return;
								}

								const imageUploaded = data[0];

								callback(imageUploaded.url, {
									title: file.name,
								});
								onUploadImageSuccess?.(imageUploaded);
							} catch (error) {
								console.error(error);
							}
						};
						reader.readAsDataURL(file);
					});
					input.click();
				},
			}}
			onDragOver={(e) => {
				e.preventDefault();
			}}
			onDrop={(e: DragEvent) => {
				const targetElement = e.target as HTMLElement;
				const files = e.dataTransfer?.files;
				const file = files?.[0];

				if (file?.type === 'image/svg+xml') {
					e.preventDefault();
					e.stopPropagation();

					const editor = editorRef.current.editor;
					const blobCache = editor.editorUpload.blobCache;
					const blobId = 'blobid' + new Date().getTime();
					const blobInfo = blobCache.create(blobId, file, file.name);
					blobCache.add(blobInfo);
					editor.editorUpload.uploadImagesAuto().then(() => {
						editor.insertContent(`<img src="${blobInfo.blobUri()}" />`);
					});
				}

				const tableCellTarget = targetElement.closest('td');

				if (!file || !tableCellTarget) return;

				const cellHeight = (tableCellTarget as HTMLTableCellElement).clientHeight;

				if (tableCellTarget) {
					e.preventDefault();

					const reader = new FileReader();
					reader.addEventListener('load', () => {
						const base64 = reader.result as string;
						const img = document.createElement('img');
						const target = tableCellTarget as HTMLTableCellElement;
						target.style.padding = '0';
						target.style.height = `${cellHeight}px`;

						img.style.width = `${target.clientWidth}px`;
						img.style.height = `${target.clientHeight}px`;
						img.style.objectFit = 'contain';
						img.style.display = 'block';
						img.style.margin = '0 auto';
						img.src = base64;

						targetElement.replaceChildren(img);
					});
					reader.readAsDataURL(file);
				}
			}}
			{...props}
		/>
	);
};

export default NhapKetQuaCDHAEditor;
